import { Context } from '@alltrails/shared/types/context';
import ApplicationLayout from 'components/ApplicationLayout';
import Checkout from 'components/Checkout';
import MinimalLayout from 'components/MinimalLayout';
import Coupon from 'types/Coupon';
import CurrencyCode from 'types/CurrencyCode';
import PaymentMethod from 'types/PaymentMethod';
import PlanCode from 'types/PlanCode';
import PlanTypeType from 'types/PlanTypeType';
import { activate } from 'utils/OptimizelyHelpers';
import LegacyCheckout from './LegacyCheckout';

type Props = {
  activePlanType: PlanCode;
  annualPlan: PlanTypeType;
  context: Context;
  coupon: Coupon;
  currencyCode: CurrencyCode;
  currentPage: string;
  locationSlug: string;
  paymentTypes: PaymentMethod[];
  planTypes: PlanTypeType[];
  recurlyPublicKey: string;
  userId: number;
  web_growth_pro_checkout_page_v1: null | 'control' | 'new_checkout';
  wideFooter: boolean;
};

export default function CheckoutRoute({
  context,
  currentPage,
  locationSlug,
  wideFooter,
  annualPlan,
  coupon,
  currencyCode,
  paymentTypes,
  planTypes,
  activePlanType,
  recurlyPublicKey,
  userId,
  web_growth_pro_checkout_page_v1
}: Props) {
  const variation = web_growth_pro_checkout_page_v1 ?? activate('web_growth_pro_checkout_page_v1');

  if (variation === 'new_checkout') {
    return (
      <MinimalLayout>
        <Checkout
          activePlanCode={activePlanType}
          coupon={coupon}
          currencyCode={currencyCode}
          plans={[...planTypes, annualPlan]}
          recurlyPublicKey={recurlyPublicKey}
          userId={userId}
        />
      </MinimalLayout>
    );
  }

  return (
    <ApplicationLayout context={context} currentPage={currentPage} locationSlug={locationSlug} wideFooter={wideFooter}>
      <LegacyCheckout
        annualPlan={annualPlan}
        coupon={coupon}
        currencyCode={currencyCode}
        paymentTypes={paymentTypes}
        planTypes={planTypes}
        recurlyPublicKey={recurlyPublicKey}
        userId={userId}
      />
    </ApplicationLayout>
  );
}
